export const ACTIVE_MARGIN_CALL_BANNER_META_FLAG = Symbol('showActiveMarginBanner');
